/*
 * @Author: kang
 * @Date: 2020-04-21 13:21:22
 * @LastEditTime: 2020-04-22 17:31:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \上海海洋\src\api\visitor-api.js
 */


import fetch from '../apiconfig/index'
// 用户登陆
export function Login(params) {
    return fetch.post(`/api/User/Login/?t=`+new Date().getTime(), params)
}
// 注销用户
export function Logout(params) {
    return fetch.get(`/api/User/Logout/?t=`+new Date().getTime(), params)
}
/* ==============================虚拟实验接口============================== */
//获取虚拟仿真实验列表-分页
export function GetExperimentArr(params) {
	return fetch.get(`/api/v1/visitor/Exp/GetExperimentArr/?t=`+new Date().getTime(), params);
}

// 获取仿真实验信息相关
export function GetExpById(params) {
	return fetch.get(`/api/v1/visitor/Exp/GetExpById/?t=`+new Date().getTime(), params);
}

/* ==============================虚拟仿真实验申报详情页面接口============================== */
// 获取虚拟信息统计
export function GetExperiment(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExperiment/?t=`+new Date().getTime(), params);
}
// 获取仿真实验成绩列表
export function GetScoreList(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetScoreList/?t=`+new Date().getTime(), params);
}
// 获取团队成员列表
export function GetExpDecTeamList(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExpDecTeamList/?t=`+new Date().getTime(), params);
}
